export * from './checkoutInitialData'

export const CHECKOUT_STORAGE_KEY = 'checkout'
export const CHECKOUT_DUMP_STORAGE_KEY = 'checkout_dump'
